import { StandardEvents } from '@shopify/events';

/**
 * <anja-stock>: swaps in the server-rendered stock status for the newly selected variant.
 */
class AnjaStock extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  /** @param {any} event */
  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then(({ detail }) => {
        const next = detail?.html?.querySelector(`anja-stock[data-block-id="${this.dataset.blockId}"]`);
        if (next) this.innerHTML = next.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('anja-stock')) customElements.define('anja-stock', AnjaStock);
